import React from 'react';

function ONama() {
  return (
    <div className="onama-container">
      <p>
        Naše druženje sa mališanima i putovanje kroz čarobni svet mašte i pozorišta počelo je davne
        1999. godine u plesnom studiju „Princ“ – gde smo napravili naše prve „korake“.
        <br /><br />
        Kroz rad sa decom, i mi smo rasli i razvijali se.
        <br /><br />
        Od 1999. do 2007. se bavimo aktivnostima vezanim za zabavu dece – animacijama na
        rođendanima, kao i organizovanjem interaktivnih predstava u okviru novogodišnjih praznika,
        manifestacija...
        <br /><br />
        Zbog potrebe da se maksimalno proširi spektar aktivnosti vezanih za zabavu dece 15.1.2007.
        osnivamo Putujuće pozorište „Kofer Teatar“.
        <br /><br />
        Od tog dana do danas, naše pozorište se družilo sa mališanima širom Srbije, u Republici
        Srpskoj, u Crnoj Gori...
        <br /><br />
        Igrali smo predstave u domovima kulture, u školskim salama, ali i učionicama, malim i
        velikim školama, vrtićima...
        <br /><br />
        Posetili smo i drugare iz domova bez roditeljskog staranja, mališane sa smetnjama u razvoju,
        učestvovali u humanitarnim akcijama i projektima...
        <br /><br />
        Kada pogledamo iza sebe, vidimo jednu metropolu nasmejanih mališana, koji su gledali naše
        predstave, učestvovali u našim animacijama i koji nam daju „krila“ – snagu, volju i želju da
        prevaziđemo sve prepreke i budemo još bolji.
        <br /><br />
        Danas, „Kofer Teatar“ ima tim talentovanih, mladih ljudi koji doprinose kvalitetu predstava i
        animacija – glumce, scenografe, reditelje, vaspitače, animatore, dramske pisce,
        kostimografe... Ljude koji se trude da stvore posebnu čaroliju za naše male gledaoce.
        <br /><br />
        Budite i Vi deo naše čarolije!
      </p>
    </div>
  );
}

export default ONama;
